import { forwardRef } from 'react';
import CloseButton from './close-button';
import NotificationCardInternal from './notification-card-internal';
var NotificationCard = forwardRef(NotificationCardInternal);
var NotificationCardNamespace = Object.assign(NotificationCard, {
    CloseButton: CloseButton,
});
export default NotificationCardNamespace;
